import { createContext as e, useContext as l } from "react";
const o = e({
  afterUploadResults: void 0,
  analyze: void 0,
  analyzeError: void 0,
  analyzeResult: void 0,
  analyzing: !1,
  autofixReport: void 0,
  beforeUploadResults: void 0,
  numCells: void 0,
  numErrorsTotalSum: void 0,
  numModificationsTotalSum: void 0,
  numNullCells: void 0,
  numRows: void 0,
  numRowsWithNullCell: void 0,
  rows: [],
  setAfterUploadResults: () => {
  },
  setBeforeUploadResults: () => {
  },
  setUploadError: () => {
  },
  setUploadLabel: () => {
  },
  setUploadProgress: () => {
  },
  setUploadResult: () => {
  },
  setUploading: () => {
  },
  upload: void 0,
  uploadError: void 0,
  uploadLabel: void 0,
  uploadProgress: void 0,
  uploadResult: void 0,
  uploading: !1,
  validationError: void 0,
  validationReport: void 0
}), t = o.Provider, d = () => l(o);
export {
  o as DatasetContext,
  t as DatasetProvider,
  d as useDataset
};
//# sourceMappingURL=DatasetContext.js.map
